const checkoutTemplate = require('../../views/checkout.html').trim();

module.exports = function ($stateProvider) {
    $stateProvider
        // Conversational Checkout Wizard routes
        .state('checkout', {
            url: '/checkout?step',
            resolve: {
                deps: ['$ocLazyLoad', '$$animateJs', function ($ocLazyLoad, $$animateJs) {
                    console.log($$animateJs);
                    return $ocLazyLoad.load(window.wowModules[4].files[0]).then(function () {
                        return $ocLazyLoad.load(window.wowModules[3].files[0]);
                    });
                }]
            },
            views: {
                '@': {
                    controller: [
                        'BreakpointsService', '$scope', 'BrowserWindowService', 'CurrentUserService', '$state', function (breakpointsService, $scope, browserWindowService, currentUserService, $state) {
                                const currentUser = currentUserService.currentUser;

                                if (currentUser.isGuest && currentUser.email === '') {
                                    $state.go('checkout.checkoutLogin');
                                } else {
                                    $scope.isSmallFormat = breakpointsService.isSmallFormat();
                                    browserWindowService.init();
                                    $scope.$on('window:resize', function () {
                                        $scope.$apply(function () {
                                            $scope.isSmallFormat = breakpointsService.isSmallFormat();
                                        });
                                    });
                                }


                        }
                    ],
                    template: checkoutTemplate
                },
                'checkout-content@checkout': {
                    controller: [
                        'BreakpointsService', '$scope', 'BrowserWindowService', function (breakpointsService, $scope, browserWindowService) {
                            browserWindowService.init();
                            $scope.isSmallFormat = breakpointsService.isSmallFormat();
                            $scope.$on('window:resize', function () {
                                $scope.$apply(function () {
                                    $scope.isSmallFormat = breakpointsService.isSmallFormat();
                                });
                            });
                        }
                    ],
                    template: '<wow-checkout-wizard class="checkout-content"></wow-checkout-wizard>'
                }
            },
            onEnter: ['FeatureService', 'CheckoutStepService', function (featureService, checkoutStepService) {
                if (featureService.isEnabled(featureService.features.checkoutPerformanceEnhancements)) {
                            checkoutStepService.setCurrentStep('delivery');
                    }
                }
            ],
            data: {
                analytics: 'bws:web:checkout',
                transitionInDirection: 'right',
                transitionOutDirection: 'right',
                pageMetadata: {
                    title: 'Checkout - BWS Online',
                    metaDescription: 'Checkout - BWS Online'
                }
            }
        })
        .state('checkout.checkoutLogin', {
            url: '/checkout-login',
            data: {
                analytics: `bws:web:checkout-login`
            },
            views: {
                'center-panel@': {
                    template: checkoutTemplate
                },
                'checkout-content@checkout': {
                    template: '<bws-checkout-login></bws-checkout-login>'
                }
            }
        })
        .state('checkout.verification', {
            url: '/idverified?guid',
            views: {
                'center-panel@': {
                    template: checkoutTemplate
                },
                'checkout-content@checkout': {
                    template: '<bws-id-verification-redirect></bws-id-verification-redirect>'
                }
            }
        })
        .state('checkout.confirmation', {
            url: '/confirmation?orderId&saveCard',
            params: {
                sendAnalytics: false
            },
            data: {
                analytics: 'bws:web:order confirmation',
                richer_relevance: ['$state', 'CheckoutService', function ($state, checkoutService) {
                    return checkoutService.getOrderConfirmation($state.params.orderId).then((res) => {
                       const items = res.data.Order.Products.map((product) => {
                           return {
                               id: product.Stockcode,
                               qty: product.Quantity,
                               price: product.SalePrice
                           };
                       });

                       if ($state.params.sendAnalytics) {
                            checkoutService.sendAnalyticsConfirmOrderDetail(res.data.Order, res.headers('x-eventid'));
                            //reset analytics data
                            checkoutService.appliedPromoCodes = [];
                       }

                       return {
                           type: 'ORDER_COMPLETE_PAGE',
                           data: {
                               id: $state.params.orderId,
                               items
                           }
                       };
                    });
                }],
                disableOrderTracker: true
            },
            views: {
                'center-panel@': {
                    template: checkoutTemplate
                },
                'checkout-content@checkout': {
                    controller: [
                        '$scope', '$state', function ($scope, $state) {
                            $scope.confirmationDetails = {
                                orderId: $state.params.orderId,
                                saveCard: $state.params.saveCard
                            };
                        }
                    ],
                    template: '<bws-order-confirmation confirmation-details="confirmationDetails"></bws-order-confirmation>'
                }
            }

        });
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/configuration/routes/checkout.js
 **/